import { apiService } from './apiService';

export function getOfferService(data) {
    return apiService({
        method: 'POST',
        url: '/offer/data',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getByIdOfferService(id) {
    return apiService({
        method: 'GET',
        url: '/offer/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function addOfferService(data) {
    return apiService({
        method: 'POST',
        url: '/offer',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function updateOfferService(id, data) {
    return apiService({
        method: 'PUT',
        url: '/offer/' + id,
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function deleteOfferService(id) {
    return apiService({
        method: 'DELETE',
        url: '/offer/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
